import {
  Modal,
  Box,
  Button,
  Autocomplete,
  TextField,
  Chip,
} from "@mui/material";
import TitreGraphik from "../Typography/TitreGraphik";
import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { urlServeur } from "../../util/env";
import { useTranslation } from "react-i18next";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

export default function AddBookingsPopup({ open, onClose, AddBookings }) {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");

  const fetchJourneys = useCallback(async () => {
    const fetchData = async () => {
      try {
        /* const response = await axios.get(
            `${urlServeur2}/externe/getBookingByCustomerOrId?page=1&perPage=10&filter=${filter}`
          );*/
        const response = await axios.get(
          `${urlServeur}/command/Getcommand&filter=${filter}`
        );
        setData(response.data.data);
      } catch (error) {
        console.error("Error fetching journeys:", error);
      }
    };

    if (filter) {
      setTimeout(fetchData, 1000);
    } else {
      fetchData();
    }
  }, [filter]);
  useEffect(() => {
    fetchJourneys();
  }, [filter, fetchJourneys]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <TitreGraphik>{t("Add Bookings")}</TitreGraphik>
        <Autocomplete
          multiple
          options={data}
          getOptionLabel={(option) =>
            `ID: ${option.id} - Customers: ${option.customers} - Price: ${option.price}`
          }
          value={selectedOptions}
          onChange={(event, newValue) => setSelectedOptions(newValue)}
          filterSelectedOptions
          renderTags={(selected, getTagProps) =>
            selected.map((option, index) => (
              <Chip
                label={option.id}
                {...getTagProps({ index })}
                key={option.id}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Select Options"
              placeholder={t("Start typing...")}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          )}
        />
        <Button
          variant="contained"
          sx={{ marginTop: "20px" }}
          onClick={() => {
            AddBookings(selectedOptions);
            onClose(false);
          }}
        >
          {t("Add bookings")}
        </Button>
      </Box>
    </Modal>
  );
}
